/**
 * 菜单事件类型
 * @type {string}
 */

export const INIT_MENU = "INIT_MENU" // 初始化菜单数据
export const ENABLE_MENU_ACTIVE = "ENABLE_MENU_ACTIVE" // 激活菜单
export const DISABLE_MENU_ACTIVE = "DISABLE_MENU_ACTIVE" // 取消激活菜单
export const SET_MODULES = "SET_MODULES" // 更新menu
export const UPDATE_MENU = "UPDATE_MENU" // menu翻页
export const SET_APPLICATION = "SET_APPLICATION" // 更新应用
export const SET_MODULE_TYPES = "SET_MODULE_TYPES" // 更新非原生的模块类型
export const SET_SYSTEM_MODULES = "SET_SYSTEM_MODULES" // 更新系统模版

export default {
  INIT_MENU,
  ENABLE_MENU_ACTIVE,
  DISABLE_MENU_ACTIVE,
  SET_MODULES,
  UPDATE_MENU,
  SET_APPLICATION,
  SET_MODULE_TYPES,
  SET_SYSTEM_MODULES
}
